"use strict";

/**
 * @param variables {{ googleLogin: {clientId: string, redirect: string} }}
 */
const ngGoogleButton = ['$lazyScripts', ($lazyScripts) => {
    return {
        async link(scope, element) {
            await $lazyScripts.loadGoogleLogin();

            window.google.accounts.id.renderButton(element[0], {...element[0].dataset});
        }
    }
}];
export default ngGoogleButton;
